<template>
  <sidebar-item-body class="pc-note__sidebar-notebook-details" name="notebookDetails">
    <div class="pc-loading" v-if="isLoading">
      <i class="el-icon-loading"></i>
      <span>加载中...</span>
    </div>
    <template v-else>
      <div class="header">名称</div>
      <div class="content">{{notebook.name}}</div>
      <div class="header">标签 ({{tags.length}})</div>
      <div class="content tags">
        <div class="tag"
          :key="tag"
          v-for="tag in tags">
          <span class="tag-name">{{tag}}</span>
          <span class="tag-remove" @click="removeTagHandler(tag)">
            <i class="el-icon-close"></i>
          </span>
        </div>
        <br v-if="tags.length > 0"/>
        <el-input v-if="inputVisible"
          ref="newTagInput"
          size="small"
          placeholder="请输入标签"
          v-model="newTag"
          @keyup.enter.native="addTagHandler"
          @blur="resetTagHandler"
          />
        <el-button v-else size="small" @click="showInputHandler"><i class="el-icon-plus" style="margin-right:.2rem;"/>标签</el-button>
      </div>
      <div class="header">发布</div>
      <div class="content">
        <p>{{publishedDesc}}</p>
        <el-button size="small" v-if="!notebook.published">发布</el-button>
        <el-button size="small" v-else>取消发布</el-button>
      </div>
      <div class="header">创建时间</div>
      <div class="content">{{notebook.createdTime | datetime}}</div>
      <div class="header">更新时间</div>
      <div class="content">{{notebook.modifiedTime | datetime}}</div>
    </template>
  </sidebar-item-body>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SidebarItemBody from '@/components/note/sidebar/SidebarItemBody.vue'
import dayjs from 'dayjs'

export default {
  components: {
    SidebarItemBody
  },
  data () {
    return {
      inputVisible: false,
      newTag: ''
    }
  },
  computed: {
    ...mapGetters('workbench/current', {
      notebook: 'notebook',
      isLoading: 'notebookLoading'
    }),
    tags () {
      return this.notebook.tags
    },
    publishedDesc () {
      if (this.notebook.published) {
        return `已发布(${dayjs(this.notebook.publishedTime).format('YYYY-MM-DD HH:mm:ss')})`
      } else {
        return '未发布'
      }
    }
  },
  methods: {
    ...mapActions({
      removeTag: 'workbench/current/removeNotebookTag',
      addTag: 'workbench/current/addNotebookTag'
    }),
    showInputHandler () {
      this.inputVisible = true
      this.$nextTick(() => {
        this.$refs.newTagInput.$refs.input.focus()
      })
    },
    resetTagHandler () {
      this.inputVisible = false
      this.newTag = ''
    },
    async addTagHandler () {
      const tag = this.newTag
      this.inputVisible = false
      this.newTag = ''
      try {
        await this.addTag(tag)
      } catch (e) {
        console.dir(e)
      }
    },
    async removeTagHandler (tag) {
      try {
        await this.removeTag(tag)
      } catch (e) {
        console.dir(e)
      }
    }
  }
}
</script>

<style lang="scss">
.pc-note__sidebar-notebook-details {
  padding: 0 1rem;
}
</style>
